import Footer from "../../component/Footer";
import { useState, useEffect } from "react";
import AgentNavbar from "../../component/AgentNavbar";
import { useNavigate } from "react-router-dom";
import RechargeNavbar from "./AgentComp/RechargeNavbar";
import axios from "axios";
import { baseurl } from "../../component/Baseurl"; // Importing baseurl
import Swal from "sweetalert2";


function RechargeAgent() {
  const [mobileNumber, setMobileNumber] = useState(""); // Mobile number state
  const [amount, setAmount] = useState(""); // Amount state
  const [circles, setCircles] = useState([]); // Circle list state
  const [selectedCircle, setSelectedCircle] = useState(""); // Selected circle state
  const [operators, setOperators] = useState([]); // Operator list state
  const [selectedOperator, setSelectedOperator] = useState(""); // Selected operator state
  const navigate = useNavigate();
  const agentid = localStorage.getItem("agent_id") || '2';

  console.log("agent id",agentid );

  // Fetch Circles List using Axios
  useEffect(() => {
    const fetchCirclesList = async () => {
      try {
        const response = await axios.get(`${baseurl}fetchCirclesList`);
        
        if (response.data?.data?.data) {
          setCircles(response.data.data.data);
        } else {
          console.error("Invalid response format:", response.data);
        }
      } catch (error) {
        console.error("Error fetching circles list:", error);
      }
    };

    fetchCirclesList();
  }, []);

  // Fetch Operators List using Axios
  useEffect(() => {
    const fetchOperatorsList = async () => {
      try {
        const response = await axios.get(`${baseurl}checkServiceList`);
        
        if (response.data?.data?.data) {
          setOperators(response.data.data.data);
        } else {
          console.error("Invalid response format:", response.data);
        }
      } catch (error) {
        console.error("Error fetching operators list:", error);
      }
    };

    fetchOperatorsList();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!/^[0-9]{10}$/.test(mobileNumber)) {
      Swal.fire("Invalid Number", "Please enter a valid 10-digit mobile number.", "error");
      return;
    }
  
    if (!selectedOperator) {
      Swal.fire("Missing Operator", "Please select an operator.", "warning");
      return;
    }
  
    if (!selectedCircle) {
      Swal.fire("Missing Circle", "Please select a circle.", "warning");
      return;
    }
  
    if (!amount || isNaN(amount) || parseFloat(amount) <= 0) {
      Swal.fire("Invalid Amount", "Please enter a valid recharge amount.", "error");
      return;
    }
  
    // Confirm before submitting
    const confirmSubmission = await Swal.fire({
      title: "Confirm Recharge",
      text: `Are you sure you want to recharge ₹${amount} for ${mobileNumber}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Proceed",
      cancelButtonText: "Cancel",
    });
  
    if (!confirmSubmission.isConfirmed) return; // Stop execution if user cancels
  
    const formData = {
      agentid: agentid,
      mobile: mobileNumber,
      operator: selectedOperator,
      circle: selectedCircle,
      amount: amount,
    };
  
    console.log("Sending Data to Backend:", formData);
  
    try {
      const response = await axios.post(`${baseurl}rechargeMobile`, formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
  
      console.log("Response from Backend:", response.data);
  
      if (response.data.success) {
        Swal.fire({
          title: "Recharge Successful!",
          text: `Request ID: ${response.data.requestId}\nTransaction ID: ${response.data.transaction?.id || "N/A"}`,
          icon: "success",
          confirmButtonText: "OK",
        }).then(() => {
          window.location.reload(); // Reloads the page
        });
      } else {
        Swal.fire("Recharge Failed", response.data.message || "Something went wrong!", "error");
      }
    } catch (error) {
      console.error("Error sending data to backend:", error);
      Swal.fire("Error", "Something went wrong. Please try again.", "error");
    }
  };
  
  
  

  return (
    <>
      <AgentNavbar />
      <div className="bgsearch1">
        <div className="container bg-2 midle">
          <RechargeNavbar />
          <h1 className="text-start agenth1 font3 txt6">Mobile Recharge</h1>
          <hr />

          <form onSubmit={handleSubmit} autoComplete="off">
            <div className="row g-3 text-start mb-3">
              {/* Mobile Number Field */}
              <div className="col-md-3 mx-0 px-0">
                <label className="text-dark mb-2 labelset1 font3">Mobile Number</label>
                <input
                  type="tel"
                  className="input2"
                  name="mobileNumber"
                  placeholder="Enter Mobile Number"
                  value={mobileNumber}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "").slice(0, 10);
                    setMobileNumber(value);
                  }}
                  required
                  maxLength="10"
                />
              </div>

              {/* Amount Field */}
              <div className="col-md-3 mx-0 px-0">
                <label className="text-dark mb-2 labelset1 font3">Amount</label>
                <input
                  type="number"
                  className="input2"
                  name="amount"
                  placeholder="Enter Amount"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  required
                  min="1"
                />
              </div>

              {/* Operator Dropdown */}
              <div className="col-md-3 mx-0 px-0">
                <label className="text-dark mb-2 labelset1 font3">Select Operator</label>
                <select
                  className="input2"
                  value={selectedOperator}
                  onChange={(e) => setSelectedOperator(e.target.value)}
                  required
                >
                  <option value="">-- Select Operator --</option>
                  {operators.map((operator) => (
                    <option key={operator.service_id} value={operator.service_code}>
                      {operator.service_name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Circle Dropdown */}
              <div className="col-md-3 mx-0 px-0">
                <label className="text-dark mb-2 labelset1 font3">Select Circle</label>
                <select
                  className="input2"
                  value={selectedCircle}
                  onChange={(e) => setSelectedCircle(e.target.value)}
                  required
                >
                  <option value="">-- Select Circle --</option>
                  {circles.map((circle) => (
                    <option key={circle.circle_id} value={circle.circle_id}>
                      {circle.circle_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div>
              <button type="submit" className="submit-btn mt-3">
                Search
              </button>
            </div>
          </form>

          <hr className="mt-4" />
          <p>The Search Bus page allows users to find bus routes and book tickets effortlessly...</p>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default RechargeAgent;
